import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from '@angular/flex-layout';
import { OAuthModule } from 'angular-oauth2-oidc';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FileUploadModule } from 'ng2-file-upload';

import { reducers } from './store/reducers';
import { UserContextComponent } from './components/user-context.component';
import { SecurityServerService } from './services/SecurityServerService';
import { SecurityServerServiceEffects } from './services/securityServerService.effects';
import { AuthenticationGuard } from './services/AuthenticationGuard';
import { appInitializerProvider } from './services/AuthenticationGuard.AppInitializer';
import { AuthenticationRedirectGuard } from './services/AuthenticationRedirectGuard';
import { ManageRolesDialogComponent } from './components/manage-roles-dialog.component';
import { PillarModule } from '../pillar/pillar.module';
import { RolesTileComponent } from './components/roles-tile.component';
import { AddRoleDialogComponent } from './components/add-role-dialog.component';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';
import { RolesService } from './services/RolesService';
import { RolesServiceEffects } from './services/RolesService.effects';
import { RoleWorkspaceComponent } from './components/role-workspace.component';
import { securityRoutes } from './routes.config';
import { ManagePermissionsDialogComponent } from './components/manage-permissions-dialog.component';
import { TokenInterceptor } from './interceptors/TokenInterceptor';
import { CurrentUserService } from './services/CurrentUserService';
import { PermissionService } from './services/PermissionService';
import { CoreModule } from '../core/core.module';
import { MyProfileDialogComponent } from './components/my-profile-dialog.component';
import { DeleteRoleConfirmationDialogComponent } from './components/delete-role-confirmation-dialog.component';
import { SupportTicketDialogComponent } from './components/support-ticket-dialog.component';
import { SupportTicketTileComponent } from './components/support-ticket-tile.component';
import { SupportTicketService } from './services/SupportTicketService';
import { SupportTicketServiceEffects } from './services/SupportTicketService.effects';
import { QuillModule } from 'ngx-quill';
import { SupportTicketWorkspaceComponent } from './components/support-ticket-workspace.component';
import { LogoutRouteComponent } from './components/logout-route.component'

@NgModule({
  entryComponents: [ManageRolesDialogComponent, RolesTileComponent, AddRoleDialogComponent, ManagePermissionsDialogComponent, MyProfileDialogComponent, DeleteRoleConfirmationDialogComponent, SupportTicketDialogComponent, SupportTicketTileComponent],
  declarations: [UserContextComponent, ManageRolesDialogComponent, RolesTileComponent, AddRoleDialogComponent, RoleWorkspaceComponent, ManagePermissionsDialogComponent, MyProfileDialogComponent, DeleteRoleConfirmationDialogComponent, SupportTicketDialogComponent, SupportTicketTileComponent, SupportTicketWorkspaceComponent, LogoutRouteComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    StoreModule.forFeature('security', reducers),
    EffectsModule.forFeature([SecurityServerServiceEffects, RolesServiceEffects, SupportTicketServiceEffects]),
    RouterModule.forChild(securityRoutes),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['*'],
        sendAccessToken: true
      }
    }),
    PillarModule,
    CoreModule,
    QuillModule,
    FileUploadModule
  ],
  exports: [UserContextComponent]
})
export class SecurityModule {
  constructor( @Optional() @SkipSelf() parentModule: SecurityModule, private dashboardTilesRegistry: DashboardTilesRegistry) {
    if (parentModule) {
      throw new Error(
        'SecurityModule is already loaded. Import it in the AppModule only');
    }

    dashboardTilesRegistry.registerTile('administration',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 2,
        tileComponent: RolesTileComponent,
        permission: "SecurityModule.Roles:View",
        displayName: "Roles"
      });

    dashboardTilesRegistry.registerTile('administration',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 2,
        tileComponent: SupportTicketTileComponent,
        permission: "ConfigurationModule.SupportTicket:View",
        displayName: "Support Ticket"
      });
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SecurityModule,
      providers: [
        SecurityServerService,
        RolesService,
        AuthenticationGuard,
        AuthenticationRedirectGuard,
        CurrentUserService,
        PermissionService,
        SupportTicketService,
        appInitializerProvider,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/security/security.module.ts